
export default function (state = {}, action) {
    switch (action.type) {
        case 'READ_WRITE':
            return { ...state, rw: action.payload }
        default:
            return state;
    }
}